//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'pop-filter-box',
  props: {
    isFixed: Boolean,   // 是否是固定定位
    manualShow: Boolean,  // 被动显示所有筛选条件
    dynamicCondition: Object, // 动态条件
    mealCountOptions: {     // 可选的含餐数量（由父组件根据后台返回数据整理）
      type: Array,
      default(){
        return [];
      },
    },
  },
  data(){
    return {
      showAll: false,
      // recommand: 1,
      condition: {
        isCanCancel: '',    // 1 免费取消，0 不可免费取消，''全部
        isOfferMeal: '',    // 1 提供，0 不提供，'' 全部
        bedType: '',        // DOUBLE大床  TWIN双床  OTHER其他
        mealCount: '',      // 含餐数量，''全部
      },
    };
  },
  watch: {
    manualShow(isShow){
      this.showAll = isShow;
    },

    dynamicCondition: {
      handler(newCondition){
        this.condition = newCondition;
      },
      deep: true,
    }
  },
  methods: {
    onClickCondition(){
      this.$emit('on-show-condition', this.isFixed);
    },

    onSetFilters(ev, filterType, immediately = false){
      const {filter} = ev.target.dataset;

      console.log(filter)
      if(filterType === 'meal'){
        this.condition.isOfferMeal = this.condition.isOfferMeal == filter ? '' : +filter;
        // this.$set(this.condition, 'isOfferMeal', +filter);
        // 非“含餐”状态时清空含餐数量条件
        if(this.condition.isOfferMeal !== 1){
          this.condition.mealCount = '';
        }else if(this.condition.mealCount === '' && this.mealCountOptions.length){
          // 进入“含餐”时默认选中第一个含餐档位（下拉已无“全部”选项）
          this.condition.mealCount = this.mealCountOptions[0];
        }
      }else if(filterType === 'bed'){
        this.condition.bedType = this.condition.bedType === filter ? '' : filter;
      }else{
        this.condition.isCanCancel = +this.condition.isCanCancel === 1 ? 0 : 1;
      }

      if(immediately) this.onConfirmFilter();
    },

    onResetCondition(){
      this.condition = {
        isCanCancel: '',    // 1 免费取消，0 不可免费取消，''全部
        isOfferMeal: '',    // 1 提供，0 不提供，'' 全部
        bedType: '',        // DOUBLE大床  TWIN双床  OTHER其他
        mealCount: '',      // 含餐数量，''全部
      };
    },

    onConfirmFilter(){
      // this.showAll = !this.showAll;
      // console.log(this.condition);
      this.$emit('on-filter-room', this.condition);
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/PopFilterBox.vue